<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">活体检测</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			传入人脸跟踪ID、红外图像数据进行活体检测。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public int SKFaceFaceVideoLiveDetectYUV(int TrackID, byte[] YUVData, int Width, int Height)</code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">
             <p class="doc_main_p">（1）TrackID：当前人脸的跟踪ID（人脸识别结果结构体中的TrackID属性）</p>
             <p class="doc_main_p">（2）YUVData：红外视频帧的YUV数据</p>
             <p class="doc_main_p">（3）Width：YUV数据宽度</p>
             <p class="doc_main_p">（4）Height：YUV数据高度</p>
        </p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">int型，-1：检测中需继续送入图像数据，0：非活体，1：活体</p>
		<pre class="doc_main_pre"><code class="doc_main_code">skFaceSDKLive.SKFaceFaceVideoLiveDetectYUV(TrackID, YUVData, Width, Height)</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Android','视频接口','活体检测'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/skfacesdklive/voideinitiali/VoideLivinga.vue